import styled from 'styled-components';

const ThreadItemCreatedAt = styled.h4`
  color: var(--on-background-grey);
  font-size: 14px;
  margin: 4px 0;
  display: flex;
  align-items: center;
`;

export default ThreadItemCreatedAt;
